/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-key */
/* eslint-disable no-unused-vars */
import Box from '@mui/material/Box';
import { useDispatch } from 'react-redux';

const images = [
  {
    pic: '13-275089821_1736665860005219_5093844010999549406_n.jpg',
  },
  {
    pic: '14-High Resolution Logo - White Background.png',
  },
];

const Boxmain = {
  paddingTop: '50px',
  ml: '30px',
};

const listBox = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBottom: '20px',
};

const imgBox = {
  marginRight: '30px',
  borderRadius: '10px',
};

const imgs = {
  borderRadius: '10px',
};

const baseUrl = window.config.API_URL;

export const ImageGrid = ({ imageData }) => {
  const dispatch = useDispatch();

  return (
    <Box sx={Boxmain}>
      <Box sx={listBox}>
        {images.map((image) => (
          <Box display="grid" border="1px solid gray" height="20rem" width="20rem" sx={imgBox}>
            <img src={`/profile/${image.pic}`} alt="nope" height="320px" width="320px" style={imgs} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
